import { render, staticRenderFns } from "./SkuNormalSetting.vue?vue&type=template&id=ea23c67e&scoped=true"
import script from "./SkuNormalSetting.vue?vue&type=script&lang=js"
export * from "./SkuNormalSetting.vue?vue&type=script&lang=js"
import style0 from "./SkuNormalSetting.vue?vue&type=style&index=0&id=ea23c67e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea23c67e",
  null
  
)

export default component.exports